/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "jelambrar",
  title: "Hi all,\nI'm Jorge Lambraño",
  subTitle: emoji(
    "A passionate Software Developer and Data Engineer 🚀 having an experience of " +
    "building applications with JavaScript / Python / Nodejs and some other cool " +
    "libraries and frameworks and SQL and No-SQL databases."
  ),
  resumeLink:
    "https://github.com/jelambrar96/resumes/blob/master/markdown/jelambrar.pdf", // Set to empty to hide the button
  useLocalResume: false, // Set to true to use local resume file
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/jelambrar96",
  linkedin: "https://www.linkedin.com/in/jorge-lambra%C3%B1o-a64662157/",
  gmail: "jelambrar@gmail.com",
  gitlab: "https://gitlab.com/jelambrar",
  medium: "https://medium.com/@jelambrar",
  stackoverflow: "https://stackoverflow.com/users/10955983/jelambrar",
  instagram: "https://www.instagram.com/jelambrar",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as AWS / Azure"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Universidad Internacional de la Rioja-UNIR",
      logo: require("./assets/images/unirLogo.png"),
      subHeader: "Máster Universitario en Inteligencia Artificial",
      duration: "Enero 2024 - Diciembre 2025",
      desc: "",
      descBullets: [
      ]
    },
    {
      schoolName: "Universidad del Norte",
      logo: require("./assets/images/uninorteLogo.png"),
      subHeader: "Ingeniero Electrónico",
      duration: "Enero 2014 - Marzo 2019",
      desc: "",
      descBullets: [
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Programming",
      progressPercentage: "90%"
    },
    {
      Stack: "Backend", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Data Engineer", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Frontend/Design",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Data Manager and Data Scientist",
      company: "Promigas SA",
      companylogo: require("./assets/images/promigasLogo.png"),
      date: "Dec 2024 - Jun 2025",
      desc: "",
      descBullets: [
        "Extract and process large volumes of geographic and energy potential data. Subsequently, cross-reference the information with various internal and external sources.",
        "Develop and implement product and service recommendation models tailored to customer needs.",
        "Analyze consumption data to identify behavioral patterns and optimization opportunities.",
      ]
    },
    {
      role: "Python and Backend instructor",
      company: "Alcaldía de Barranquilla",
      companylogo: require("./assets/images/escudobaq.png"),
      date: "Feb 2024 - Dec 2024",
      desc: "",
      descBullets: [
        "Develop and organize educational programs tailored to the development of Python programming skills and computational thinking.",
        "Explain complex concepts in a clear and comprehensible manner.",
        "Create tests and projects to assess understanding and application of knowledge.",
      ]
    },    
    {
      role: "Data Engineer",
      company: "Pragma SA",
      companylogo: require("./assets/images/pragmaLogo.png"),
      date: "Mar 2023 - Sep 2023",
      desc: "",
      descBullets: [
        "Build ETL processes to obtain structuring and unstructured corporate data analysis.", 
        "Implement AWS cloud computing tools for processing structured and unstructured data. AWS Lambda, AWS Glue, AWS S3.", 
        "Use data visualization tools to improve data understanding. Superset.", 
      ]
    },
    {
      role: "Backend Developer and Data Engineer",
      company: "E2 Energia Eficiente SA",
      companylogo: require("./assets/images/e2Logo.png"),
      date: "Jun 2021 - Mar 2023",
      descBullets: [
        "Collect and process and generate reports of large volumen of data. Grafana. ", 
        "Design and develop databases to store the collected data. SQL relational and non-relational databases MongoDB, InfluxDB.", 
        "Use data visualization tools to improve data understanding. Grafana, PowerBI, Tableau, QlikView and D3.js.", 
        "Perform predictive analyzes to make informed decisions.", 
      ]
    },
    {
      role: "Software Engineer",
      company: "Ebenezer Technologies SAS",
      companylogo: require("./assets/images/ebenezerLogo.png"),
      date: "Feb 2019 - Jun 2021",
      descBullets: [
        "Design and develop of computer vision algorithms to process large amounts of data. C++.", 
        "Create artificial vision models for object detection and tracking. C++.", 
        "Implement Deep Learning and Machine Learning techniques to improve results in artificial vision systems.", 
        "Optimize artificial vision systems for better performance. ", 
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    /*
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
    */
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    /*
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
    */
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
/*
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
*/ 
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "Talks",
  subtitle: emoji(
    "I love to share my knowledge by giving talks at local meetups and conferences."
  ),

  talks: [
    {
      title: "Monitorea tu servidor local con telegraf, influxdb y grafana",
      subtitle: "¿Cómo hacer seguimiento al uso de los recursos de nuestro hardware?",
      slides_url: "https://github.com/jelambrar96/telegraf-influxdb2-grafana/blob/master/presentacion/presentacion.pdf",
      event_url: "https://www.youtube.com/live/oGZobb0C9JQ?si=370BVxR5_v7H8qyP"
    },
    {
      title: "Descubre el valor de los datos geoespaciales",
      subtitle: "Procesamiento y visualización con herramientas opensource",
      slides_url: "https://github.com/jelambrar96/procesamiento-geoespacial/blob/master/presentacion/jorge-lambrano-opensatBQ-2025.pdf",
      event_url: "https://youtu.be/6pcoxTLzt6U?t=6836"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I love to talk about technology and development",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    // "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+57-3045653650",
  email_address: "jelambrar@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "jelambrar", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
